import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { useMemo, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import modulosData from '@content/modulos.json'
import { topicoDetailPath } from '@utils/constants.js'

interface SearchHit {
  topicoId: string
  titulo: string
  moduloId: string
  moduloTitulo: string
  ordem: number
}

const INDEX: SearchHit[] = modulosData.modulos.flatMap((m) =>
  m.topicos.map((t) => ({
    topicoId: t.id,
    titulo: t.titulo,
    moduloId: m.id,
    moduloTitulo: m.titulo,
    ordem: t.ordem,
  })),
)

export function JornadaSearch() {
  const navigate = useNavigate()
  const [query, setQuery] = useState('')

  const results = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (q.length < 2) return []
    return INDEX.filter(
      (h) => h.titulo.toLowerCase().includes(q) || h.moduloTitulo.toLowerCase().includes(q),
    ).slice(0, 8)
  }, [query])

  const onSelect = useCallback(
    (hit: SearchHit) => {
      navigate(topicoDetailPath(hit.moduloId, hit.topicoId))
    },
    [navigate],
  )

  return (
    <div className='cf3-search'>
      <label className='cf3-search__label' htmlFor='jornada-search'>
        {GUIA_LABELS.buscarEtapasGuia}
      </label>
      <input
        id='jornada-search'
        type='search'
        className='cf3-search__input'
        placeholder='Ex.: fundação, INSS, alvenaria…'
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        autoComplete='off'
      />
      {results.length > 0 && (
        <ul className='cf3-search__results' role='listbox'>
          {results.map((hit) => (
            <li key={hit.topicoId}>
              <button type='button' className='cf3-search__hit' onClick={() => onSelect(hit)}>
                <span className='cf3-search__hit-title'>{hit.titulo}</span>
                <span className='cf3-search__hit-meta'>{hit.moduloTitulo}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
      {query.trim().length >= 2 && results.length === 0 && (
        <p className='cf3-search__empty'>{GUIA_LABELS.nenhumaEtapaEncontrada}</p>
      )}
    </div>
  )
}
